import { format } from "date-fns";

/**
 * Epoch ms <-> the local `Date` the calendar speaks. Stored bounds are UTC and the calendar is
 * local, so these carry the calendar day across intact: never hand a raw `new Date(ms)` to the
 * calendar, and never read a picked date with the UTC accessors.
 */

export type DateBound = "start" | "end";

export function msToCalendarDate(ms: number | undefined): Date | undefined {
  if (ms == null || !Number.isFinite(ms)) return undefined;
  const utc = new Date(ms);
  return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
}

/** End bounds snap to the last ms of the day, or a range ending "Aug 5" excludes Aug 5. */
export function calendarDateToMs(date: Date, bound: DateBound): number {
  const [year, month, day] = [
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  ];

  return bound === "end"
    ? Date.UTC(year, month, day, 23, 59, 59, 999)
    : Date.UTC(year, month, day);
}

export function formatBound(ms: number): string {
  const date = msToCalendarDate(ms);
  return date != null ? format(date, "LLL d, yyyy") : "";
}
